import storiesSimilar from "core/templates/collection-views/stories-similar.hbs";
import addToLibraryModal from "core/templates/components/add-to-library-modal.hbs";
import storyParts from "core/templates/story-landing/story-parts.hbs";
import storyDetails from "core/templates/story-landing/story-details.hbs";
import storyLanding from "platform/story-landing/templates/story-landing.hbs";
(function(window, _, $, wattpad, utils, app, Monaco, document) {
  "use strict";
  app.add(
    "StoryLanding",
    app.views.RegionManager.extend({
      template: storyLanding,

      id: "story-landing",
      className: "container", //row

      partials: {
        "core.story_landing.story_details": storyDetails,
        "core.story_landing.story_parts": storyParts,
        "core.collection_views.stories_similar": function() {
          return "";
        },

        "core.components.add_to_library_modal": addToLibraryModal
      },

      events: {
        "tap    .on-tab-nav": "onSectionNavigate",
        "click  .on-tab-nav": "stopEvent",

        "tap    .on-showmore-description": "onShowMore",
        "click  .on-showmore-description": "stopEvent",

        "tap    .on-read-story-navigate": "onReadStory",
        "click  .on-read-story-navigate": "stopEvent",

        "tap .on-sponsor-navigate": "onSponsorNavigate",
        "click .on-sponsor-navigate": "stopEvent",

        "tap .on-ranking-navigate": "onRankingNavigate",
        "click .on-ranking-navigate": "stopEvent",

        "tap .send-author-event": "sendAuthorClickTrackingEvent",
        "click .send-author-event": "stopEvent",

        "tap .send-story-cover-event": "sendSimilarStoryCoverTrackingEvent",
        "click .send-story-cover-event": "stopEvent"
      },

      initialize: function(options) {
        options = options || {};

        _.each(this.partials, function(value, key, list) {
          Handlebars.registerPartial(key, value);
        });

        //Push empty functions for the partials, we will render them later
        _.each(this.partials, function(value, key) {
          Handlebars.registerPartial(key, value);
        });

        //Reduce to 1 category
        //TODO: Make this code assume 1 category when platform completely kills
        //the second category
        this.model.set("categories", [
          _.find(this.model.get("categories"), function(category) {
            return category > 0;
          })
        ]);

        // categoryLabels needed for social-sharing mixin
        this.model.set(
          "categoryLabels",
          _.reduce(
            this.model.get("categories"),
            function(models, cat) {
              var search = app.get("categories").get(cat);
              if (search) {
                models.push({
                  name: search.get("name"),
                  name_english: search.get("name_english")
                });
              }
              return models;
            },
            []
          )
        );

        this.storiesView = new app.views.StoriesSimilar({
          storyId: this.model.get("id"),
          showDescription: true
        });

        var device = app.get("device");
        this.descCharLimit = device.is.mobile ? 130 : 170;

        var category = false;
        if (this.model.get("categories")) {
          category = this.model.get("categories")[0];
        }

        this.promotedStoryView = new app.views.PromotedStoryItem({
          storyId: this.model.get("id"),
          baseStoryCategory: category,
          zoneIds: [170406],
          template: storiesSimilar,
          fromPage: "storyLanding",
          descCharLimit: this.descCharLimit,
          promotedEl: ".promoted-story-container"
        });

        this.listenTo(
          this.model,
          "reading-position-available",
          this.onPositionAvailable
        );
        this.listenTo(
          app,
          "app:component:TagCarouselItem:click",
          this.navigateToTagPage
        );
      },

      setElement: function(el) {
        Monaco.View.prototype.setElement.apply(this, arguments);

        if (this.storiesView) {
          this.storiesView.setElement(this.$("#similar-stories > .stories"));
        }
      },

      onPositionAvailable: function(data) {
        if (
          (data && data.part !== this.model.get("firstPartId")) ||
          data.position > 0
        ) {
          //Update table of contents
          var partEntry = this.$("li[data-part-id='" + data.part + "']");
          var anchor = $(partEntry).children("a");
          var text = data.position * 100 + "%";

          partEntry.addClass("active");
          anchor.children().remove();
          anchor.append('<small class="pull-right">' + text + "</small>");

          //Update Read/Continue Reading button
          var storyPart = _.find(this.model.get("parts"), function(part) {
            return part.id === data.part;
          });
          if (storyPart) {
            this.$(".story-controls > .on-read-story-navigate")
              .text(wattpad.utils.trans("Continue"))
              .attr("href", wattpad.utils.formatStoryUrl(storyPart.url));
          }
        }
      },

      navigateToTagPage: function(tag, evt) {
        var urlPath = "/stories/";
        window.te.push("event", "story_details", "tag", null, "click", {
          storyid: this.model.get("id"),
          tags: tag
        });

        app.router.navigate(urlPath + encodeURIComponent(tag), {
          trigger: true
        });
      },

      render: function() {
        var data = {};
        data.isMobile = utils.getDeviceType() === "mobile"; // for story-details.hbs
        data.story = this.model.toJSON();

        data.story.firstPart = _.find(data.story.parts, function(part) {
          return part.id === data.story.firstPartId;
        });

        data.relatedTags = { tags: [] };
        _.each(this.model.get("tags"), function(tag) {
          data.relatedTags.tags.push({ key: tag, name: tag });
        });

        if (data.story.promoted) {
          //always use author name as fallback when sponsor name is not defined
          data.story.sponsorName =
            data.story.sponsorName || data.story.user.username;
        }

        data.descCharLimit = this.descCharLimit;
        data.reportUrl =
          "/help/content?message=" +
          wattpad.utils.urlEncode("I am reporting the following content:\n") +
          "&story_link=" +
          wattpad.utils.urlEncode(window.location.href);

        if (data.story.sourceLink) {
          data.story.sourceLink.icon =
            data.story.sourceLink.label.indexOf("Amazon") > -1
              ? "fa-buy"
              : "fa-website";
        }

        //set cookie for signupForm
        wattpad.utils.setCookie(
          "signupFrom",
          "story_landing",
          0,
          window.location.hostname.replace("www", "")
        );

        const paidContentEnabled =
          _.get(window, "wattpad.testGroups.PAID_CONTENT") || false;
        if (paidContentEnabled && data.story.isPaywalled) {
          const { paidMetadata } = window.store.getState();
          data.story.parts = utils.markBlockedParts(
            paidMetadata,
            data.story.parts
          );
          data.story.isPaidPreview = utils.isPaidPreview(data.story.parts);
        }

        this.$el.html(this.template(data));
        if (!data.story.deleted) {
          this.$(".similar-stories")
            .empty()
            .append(this.storiesView.render().$el);
          var self = this;
          _.defer(function() {
            self
              .$(".promoted-stories")
              .empty()
              .append(self.promotedStoryView.render().$el);
          });
        }

        if (wattpad.utils.currentUser().authenticated()) {
          this.model.syncPosition();
        }

        return this;
      },

      onShowMore: function(evt) {
        this.$(".description").html(this.model.get("description"));
      },

      onAddToListsReady: function($btn, storyId) {
        this.$(".addToLibraryModal[data-story-id='" + storyId + "']").modal({
          show: true
        });
      },

      onAddedToLibrary: function(storyId) {
        var $button = this.$(
          this.libraryButton + "[data-story-id='" + storyId + "']"
        );
        $button
          .children(".fa")
          .removeClass("fa-plus")
          .addClass("fa-check");
      },

      onRemovedFromLibrary: function(storyId) {
        var $button = this.$(
          this.libraryButton + "[data-story-id='" + storyId + "']"
        );
        $button
          .children(".fa")
          .addClass("fa-plus")
          .removeClass("fa-check");
      },

      getDeepLinkPage: function() {
        return "story-landing";
      },

      onReadStory: function(e) {
        window.te.push("event", "story_details", "story", null, "read", {
          storyid: this.model.get("id")
        });
        this.onNavigate(e);
      },

      onSponsorNavigate: function(evt) {
        var url = $(evt.target).data("clickUrl");
        $.ajax({
          type: "GET",
          url: url
        });
        this.onNavigate(evt);
      },

      onRankingNavigate: function(evt) {
        window.te.push("event", "story_details", "tag_ranking", null, "click", {
          storyid: this.model.get("id"),
          tag: this.model.get("tagRankings")[0].name
        });
        this.onNavigate(evt);
      },

      sendAuthorClickTrackingEvent: function() {
        window.te.push("event", "story_details", "author", "", "click", {
          storyid: this.model.get("id"),
          username: this.model.get("user").username
        });
      },

      sendSimilarStoryCoverTrackingEvent: function(evt) {
        window.te.push(
          "event",
          "story_details",
          "similar_stories",
          "cover",
          "click",
          {
            storyid: $(evt.currentTarget).data("story-id"),
            current_storyid: this.model.get("id")
          }
        );
      }
    })
  );

  app.mixin(
    app.views.StoryLanding,
    "StoryInListsManagement",
    "LibraryManagement"
  );
})(
  window,
  _,
  jQuery,
  wattpad,
  wattpad.utils,
  window.app,
  window.Monaco,
  window.document
);
